import React, { Component } from "react";
import PropTypes from "prop-types";
import { Dropdown, MenuItem, Glyphicon } from "react-bootstrap";

import NotificationBadge from "react-notification-badge";
import { Effect } from "react-notification-badge";
import notification from '../../Assets/notification.svg'
import "./style.css";

// Local Components

class HsgToggle extends Component {
    constructor(props) {
        super(props);

        this.handleToggleClick = this.handleToggleClick.bind(this);
    }

    render() {
        return (
            <div
                className="hsg-header-alert-root"
                bsrole={this.props.bsRole || "toggle"}
                onClick={this.handleToggleClick}
            >
                {this.props.children}
            </div>
        );
    }

    handleToggleClick(e) {
        e.preventDefault();

        this.props.onClick(e);
    }
}

class HsgMenu extends Component {
    constructor(props, context) {
        super(props, context);
    }

    render() {
        return (
            <div className="dropdown-menu hsg-header-alert-menu custom-drop-down-outline" onClick={this.props.onClick}>
                {this.props.children}
            </div>
        );
    }
}

// Primary Component

export default class HeaderAlerts extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showMenu: false
        };

        this.handleToggle = this.handleToggle.bind(this);
        this.onClickMenu = this.onClickMenu.bind(this);
    }

    closeOnBlur = () => {
        this.setState({ showMenu: false });
    };

    render() {
        return (
            <div className="no-focus-outline" onBlur={() => this.closeOnBlur()} tabIndex="0">
                <Dropdown id="hsg-header-bell-dropdown" open={this.state.showMenu} onToggle={this.handleToggle} onClose={() => this.setState({showMenu: false})}>
                    <HsgToggle bsRole="toggle">
                        <div style = {{display:'flex', flexDirection: 'column',}}>
                            <img src= {notification} style={{height:'25px'}} />
                            <NotificationBadge
                                count={this.props.count}
                                effect={Effect.SCALE}
                                style={{width:12,height:12,borderRadius:'100%', fontSize: 8, top: -10, padding: 2, backgroundColor: '#4080FF',left:35 }}
                            />
                            <div style = {{fontSize:10, fontWeight: 700, marginTop:5, marginLeft:-4 }}>NOTIFICATIONS</div>
                        </div>
                    </HsgToggle>

                    <HsgMenu bsRole="menu" onClick={this.onClickMenu}>
                        {this.props.bellIcon}
                    </HsgMenu>
                </Dropdown>
            </div>
        );
    }

    handleToggle(status) {
        this.setState({ showMenu: status });
        this.props.updateAlerts()
    }

    onClickMenu() {
        this.setState({ showMenu: false });
        this.props.updateAlerts()
    }
}

HeaderAlerts.propTypes = {};



// WEBPACK FOOTER //
// ./src/Components/HeaderAlerts/index.js